import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ShopShopPolicyActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Shop/ShopPolicy/ShopPolicyBrowser")
	}

	render() {
		return (
			<Activity 
				name="ShopShopPolicy"
				RenderedComponent={this.RenderedComponent}
				context="ShopShopPolicy"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ShopShopPolicyActivity)
